// extracted by mini-css-extract-plugin
module.exports = {"rowLeft":"suggested-workspace_rowLeft_YRB"};